// File: src/pages/ForgotPassword.js

import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import logo from '../assets/images/nesim-logo.jpg'
import './ForgotPassword.css'
import { post } from '../api'  // centralized API helper

export default function ForgotPassword() {
  const [email, setEmail] = useState('')
  const [status, setStatus] = useState('idle')   // 'idle' | 'pending' | 'success' | 'error'
  const [error, setError] = useState(null)

  const handleSubmit = async e => {
    e.preventDefault()
    setError(null)
    setStatus('pending')

    try {
      // post() prefixes with /api and injects your token header
      await post('/auth/forgot-password', { email })
      setStatus('success')
    } catch (err) {
      // extract error message from the response if available
      const msg =
        err.response?.data?.error ||
        err.response?.data?.message ||
        err.message ||
        `Request failed`
      setError(msg)
      setStatus('error')
    }
  }

  return (
    <div className="forgot-password-page">
      <div className="forgot-password-container">
        <img src={logo} alt="NESIM Logo" className="forgot-password-logo" />
        <h2>Forgot Password</h2>

        {status === 'success' ? (
          <div className="message success">
            If that email is registered, you’ll receive a reset link shortly.
          </div>
        ) : (
          <form className="forgot-password-form" onSubmit={handleSubmit}>
            {error && <div className="message error">{error}</div>}

            <label>Email Address</label>
            <input
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
              disabled={status === 'pending'}
            />

            <button type="submit" disabled={status === 'pending'}>
              {status === 'pending' ? 'Sending…' : 'Send Reset Link'}
            </button>
          </form>
        )}

        <div className="back-to-login">
          <Link to="/login">← Back to Login</Link>
        </div>
      </div>
    </div>
  )
}
